// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sa-answer-result-title-link {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/plugins/answers/templates/SearchResultsTemplate/searchResultsTemplate.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;AACJ","sourcesContent":[".sa-answer-result-title-link {\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
